import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const opportunityDataClassName = DataClassName.OPPORTUNITY
const opportunityEndpoint = PisaDataClassEndpoint.OPPORTUNITY

export function pisaOpportunityDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(opportunityDataClassName, {
    title: opportunityDataClassName,
    restApi: createPisaRestApiConfig(opportunityEndpoint),
    attributes,
  })
}
